import { gql } from 'apollo-angular';
import { DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT } from "./discount-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_DOCUMENT_RELATION_FRAGMENT = gql`
fragment DiscountGroupDocumentRelation on DiscountGroupDocumentRelation {
    ...DiscountGroupRelationDocumentBase
}
${DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_DOCUMENT_RELATIONS = gql`
query GetDiscountGroupDocumentRelations($input:DiscountGroupDocumentRelationSearchInput) {
    getDiscountGroupDocumentRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupDocumentRelation
        }
    }
}
${DISCOUNT_GROUP_DOCUMENT_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_DOCUMENT_RELATION = gql`
query GetDiscountGroupDocumentRelation($id:String!) {
    getDiscountGroupDocumentRelation(id: $id) {
        ...DiscountGroupDocumentRelation
    }
}
${DISCOUNT_GROUP_DOCUMENT_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_DOCUMENT_RELATION = gql`
mutation SaveDiscountGroupDocumentRelation($input: DiscountGroupDocumentRelationInput!) {
    saveDiscountGroupDocumentRelation(input: $input) {
        ... DiscountGroupDocumentRelation
    }
}
${DISCOUNT_GROUP_DOCUMENT_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_DOCUMENT_RELATION = gql`
mutation DeleteDiscountGroupDocumentRelation($id: String!) {
    deleteDiscountGroupDocumentRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;